import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { components } from "@/client/backend/zz_schema";

interface StatusBadgeProps {
    state: components["schemas"]["AndroidInstanceState"];
}

export function StatusBadge({ state }: StatusBadgeProps) {
    return (
        <Badge variant="outline" className={cn(
            "border px-2 py-0.5 text-xs font-medium",
            {
                "border-green-200 bg-green-50 text-green-700": state === "ready",
                "border-gray-200 bg-gray-50 text-gray-700": state === "terminated",
                "border-yellow-200 bg-yellow-50 text-yellow-700": state === "unknown"
            }
        )}>
            {state}
        </Badge>
    );
} 